import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const SHADOW_BLACK = "5px 5px 0 0 #0A0A0A";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="relative bg-[#F5F5F0] min-h-screen flex items-center justify-center px-4 md:px-8 pt-24 pb-20 overflow-hidden"
    >
      <div className="portfolio-dots" aria-hidden="true" />

      <div className="relative max-w-2xl mx-auto text-center">
        <p className="font-arcade text-base text-[#15803D] uppercase tracking-widest mb-4">
          &gt; SYSTEM.404
        </p>

        <h1
          className="font-pixel text-stroke-ink leading-[0.85] text-[18vw] md:text-[12vw] xl:text-[160px] text-[#EDEDE7] mb-6"
          style={{ letterSpacing: "-0.02em" }}
        >
          404
        </h1>

        <h2 className="font-pixel text-xl md:text-3xl text-[#0A0A0A] leading-tight mb-4">
          PAGE NOT FOUND
        </h2>

        <p className="font-terminal text-sm md:text-base text-[#0A0A0A]/70 leading-relaxed mb-10 max-w-md mx-auto">
          The page you are looking for does not exist, has moved, or never made it to production.
          Head back home and try again.
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[#4ADE80] text-black font-arcade text-base uppercase px-6 py-3 border-2 border-[#0A0A0A] hover:bg-[#FBBF24] transition-colors duration-150 btn-press"
          style={{ boxShadow: SHADOW_BLACK }}
        >
          GO HOME <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
